import { useEffect, useRef, useState } from "react";
import { ReactComponent as Facebook } from "./assets/logo-facebook.svg";
import { ReactComponent as Linkedin } from "./assets/logo-linkedin.svg";
import { ReactComponent as Whatsapp } from "./assets/logo-whatsapp.svg";
import { ReactComponent as X } from "./assets/logo-x.svg";
import { ReactComponent as CopyLink } from "./assets/copy-link.svg";
import clsx from "clsx";
import style from "./share-tooltip.module.scss";

const ShareTooltip = ({ showTooltip, setShowTooltip, text, url }) => {
  const [showMessageLink, setShowMessageLink] = useState(false);
  const tooltipRef = useRef(null);

  // Close the tooltip if a click happens outside of it
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (tooltipRef.current && !tooltipRef.current.contains(event.target)) {
        setShowTooltip(false);

        setTimeout(() => {
          setShowMessageLink(false);
        }, 200);
      }
    };

    if (showTooltip) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showTooltip, setShowTooltip]);

  const shareTwitter = () => {
    window.open(
      `https://x.com/intent/tweet?text=${encodeURIComponent(
        text
      )}&url=${encodeURIComponent(url)}`,
      "_blank"
    );
  };

  const shareLinkedin = () => {
    window.open(
      `https://www.linkedin.com/shareArticle?mini=true&text=${encodeURIComponent(
        text
      )}&url=${encodeURIComponent(url)}`,
      "_blank"
    );
  };

  const shareFacebook = () => {
    window.open(
      `https://www.facebook.com/sharer/sharer.php?u=${url}`,
      "_blank"
    );
  };

  const shareWhatsapp = () => {
    window.open(
      `https://api.whatsapp.com/send?text=${encodeURIComponent(
        text
      )}%20${encodeURIComponent(url)}`,
      "_blank"
    );
  };

  const copyLink = () => {
    navigator.clipboard.writeText(url);
    setShowMessageLink(true);
  };

  return (
    <div
      ref={tooltipRef}
      className={clsx(style.tooltip, showTooltip && style.visible)}
    >
      <div className={style.shareContainer}>
        <button className={style.button} onClick={shareFacebook}>
          <Facebook className={style.icon} />
        </button>

        <button className={style.button} onClick={shareTwitter}>
          <X className={style.icon} />
        </button>

        <button className={style.button} onClick={shareLinkedin}>
          <Linkedin className={style.icon} />
        </button>

        <button className={style.button} onClick={shareWhatsapp}>
          <Whatsapp className={style.icon} />
        </button>

        <button className={style.button} onClick={copyLink}>
          <CopyLink className={style.icon} />
        </button>
      </div>

      {showMessageLink && (
        <div className={style.messageCopy}>
          <p>Le lien a été copié dans le presse-papier.</p>
        </div>
      )}
    </div>
  );
};

export default ShareTooltip;
